export default "__VITE_ASSET__CtR0k_Gx__"